import { Stack, Text } from '@chakra-ui/react';
import React from 'react';
import { PAGE_SIZE } from '~/constants';
import { PaginationItem } from './PaginationItem';
import { Select } from '~/components';

interface PaginationProps {
  totalCountOfRegisters: number;
  registersPerPage?: number;
  currentPage?: number;
  onPageChange: (page: number) => void;
  marginTop?: string;
  onPageSizeChange?: (pageSize: React.ChangeEvent<HTMLSelectElement>) => void;
}

const siblingsCount = 1;

function generatePagesArray(from: number, to: number) {
  return [...new Array(to - from)]
    .map((_, index) => {
      return from + index + 1;
    })
    .filter(page => page > 0);
}

export const Pagination: React.VFC<PaginationProps> = ({
  totalCountOfRegisters,
  registersPerPage = PAGE_SIZE,
  currentPage = 1,
  onPageChange,
  marginTop = '8',
  onPageSizeChange = null,
}) => {
  const lastPage = Math.ceil(totalCountOfRegisters / registersPerPage);

  const previousPages =
    currentPage > 1
      ? generatePagesArray(currentPage - 1 - siblingsCount, currentPage - 1)
      : [];

  const nextPages =
    currentPage < lastPage
      ? generatePagesArray(
          currentPage,
          Math.min(currentPage + siblingsCount, lastPage),
        )
      : [];

  return (
    <Stack
      direction={['row']}
      spacing="6"
      mt={marginTop}
      justify="sp ace-between"
      align="center"
    >
      {onPageSizeChange && (
        <Select
          name="pagesize"
          label="Registros por página:"
          onChange={e => onPageSizeChange(e)}
          value={registersPerPage}
          formControlWidth="220px"
          formControlJustifyContent="space-between"
          width="80px"
          height="32px"
          isRowSelect
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </Select>
      )}
      <Stack direction="row" spacing="2">
        {currentPage > 1 + siblingsCount && (
          <>
            <PaginationItem onPageChange={onPageChange} number={1} />
            {currentPage > 2 + siblingsCount && (
              <Text color="gray.300" w="8" textAlign="center">
                ...
              </Text>
            )}
          </>
        )}

        {previousPages.length > 0 &&
          previousPages.map(page => {
            return (
              <PaginationItem
                onPageChange={onPageChange}
                key={page}
                number={page}
              />
            );
          })}

        <PaginationItem
          onPageChange={onPageChange}
          number={currentPage}
          isCurrent
        />

        {nextPages.length > 0 &&
          nextPages.map(page => {
            return (
              <PaginationItem
                onPageChange={onPageChange}
                key={page}
                number={page}
              />
            );
          })}

        {currentPage + siblingsCount < lastPage && (
          <>
            {currentPage + 1 + siblingsCount < lastPage && (
              <Text color="gray.900" w="8" textAlign="center">
                ...
              </Text>
            )}
            <PaginationItem onPageChange={onPageChange} number={lastPage} />
          </>
        )}
      </Stack>
    </Stack>
  );
};
